/**
 * Created by mh on 2017/5/23.
 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observer, inject } from 'mobx-react';

import { MdRefresh } from 'react-icons/md';

import AssetTable from './AssetTable';
import TableLimit from '../core/TableLimit';
import TableFilter from '../core/TableFilter';
import TableNotRelated from '../core/TableNotRelated';
import TableSummary from '../core/TableSummary';
import TablePagination from '../core/TablePagination';

import Spinner from '../Spinner';

@inject('auth', 'assets') @observer
class Assets extends Component {
    componentDidMount = () => {
        const { assets, match } = this.props;
        assets.page = match.params.page ? match.params.page - 1 : 0;
        assets.type = match.params.type;
        assets.fetch();
        // this.props.assets.syncUpdate();
    };

    componentWillReceiveProps = (nextProps) => {
        const { assets, match } = this.props;
        // TODO is this right ?
        if (nextProps.match.params.type !== match.params.type) {
            assets.type = nextProps.match.params.type;
            assets.fetch();
        }
        if (nextProps.match.params.page !== match.params.page) {
            assets.page = nextProps.match.params.page ? nextProps.match.params.page - 1 : 0;
            assets.fetch();
        }
    };

    componentWillUnmount = () => {
        // this.props.assets.unsyncUpdates();
    };

    reload = () => {
        const { assets } = this.props;
        assets.page = 0;
        assets.fetch();
    };

    myAction = () => {
    };

    render() {
        const { assets, auth, match } = this.props;
        if (auth) {
            console.log('Authentication isLoggedIn', auth.isLoggedIn, auth.isLoggingIn);
        } else {
            console.log('Authentication not set yet.');
        }

        return (
            <section>
                <h1>
                    <FormattedMessage id="Assets.Assets" defaultMessage="Assets" />
                    {match.params.type
                        ? <small> {match.params.type}</small> : null}
                </h1>
                <div className="row">
                    <div className="mx-auto">
                        <TablePagination store={assets} />
                    </div>
                    <div className="form-inline">
                        {match.params.type === 'audio' ? <TableNotRelated store={assets} /> : null}
                        <TableFilter store={assets} />
                        <TableLimit store={assets} />
                        <div className="btn btn-secondary" onClick={this.reload} onKeyDown={this.myAction}>
                            <MdRefresh />
                        </div>
                    </div>
                </div>
                {assets.fetching ? <Spinner /> : <AssetTable assets={assets.filtered} columns={assets.columnsConfig} /> }
                <TableSummary store={assets} />
            </section>
        );
    }
}

Assets.wrappedComponent.propTypes = {
    assets: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default injectIntl(Assets);
